import React from 'react'
import { Grid, Input, InputSelect } from '@enterprise-ui/canvas-ui-react'
import '../../Cases/Custom.css'
import {
  VI19_SUB_REASON_CODES,
  VI19_REASON_CODE,
} from '../Services/ConstantData'
import { FormikValues } from 'formik'

interface CreatePaymentMethodSelectProps {
  subReasonCodeText2Label: string
  formik: FormikValues
  state: any
  env: any
}

const CreatePaymentMethodSelect: React.FC<CreatePaymentMethodSelectProps> = ({
  subReasonCodeText2Label,
  formik,
  state,
  env,
}) => (
  <>
    <Grid.Container className="hc-pt-none hc-ml-expanded">
      <Grid.Item xs={10} md={10} className="hc-pt-md">
        <Input.Label
          required={
            formik.values.reasonCode === VI19_REASON_CODE &&
            formik.values.subReasonCode === VI19_SUB_REASON_CODES.PAYMENT_METHOD
          }
        >
          {subReasonCodeText2Label}
        </Input.Label>
        <InputSelect
          disabled={state.showDocuments}
          id="subReasonCodeText2"
          options={env.vi.viPaymentMethod}
          onUpdate={(id: any, value: any) => {
            formik.setFieldValue('subReasonCodeText2', value)
          }}
          value={formik.values.subReasonCodeText2}
          error={formik.errors.subReasonCodeText2 !== undefined}
        />
      </Grid.Item>
    </Grid.Container>
    <Grid.Container className="hc-pt-none hc-ml-expanded hc-pb-dense">
      <Grid.Item xs={10} md={10} className="hc-pb-none hc-pt-none">
        <Input.Info error={formik.errors.subReasonCodeText2 !== undefined}>
          {formik.errors.subReasonCodeText2}
        </Input.Info>
      </Grid.Item>
    </Grid.Container>
  </>
)

export default CreatePaymentMethodSelect
